import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import type { Position } from '@core/http-types';
import { injectReportsHttpApiService } from '@core/reports-contracts';
import type {
  ReportDashboard,
  ReportDashboardApiEntity,
  ReportDashboardComponentGridPosition,
  ReportsDashboardCreate,
  ReportsDashboardsHttpClientService,
} from '@core/reports-types';

@Injectable()
export class ReportsDashboardsHttpClient implements ReportsDashboardsHttpClientService {
  private readonly http = injectReportsHttpApiService();

  public fetchCollection(): Observable<{ dashboards: ReportDashboardApiEntity[] }> {
    return this.http.get<{ dashboards: ReportDashboardApiEntity[] }>('/dashboards');
  }

  public fetchOne(id: number): Observable<{ dashboard: ReportDashboardApiEntity }> {
    return this.http.get<{ dashboard: ReportDashboardApiEntity }>(`/dashboards/${id}`);
  }

  public createOne(
    dashboardToCreate: ReportsDashboardCreate,
  ): Observable<{ dashboard: ReportDashboardApiEntity }> {
    return this.http.post<{ dashboard: ReportDashboardApiEntity }>('/dashboards', null, {
      dashboard: dashboardToCreate,
    });
  }

  public updateOne(
    dashboard: Partial<ReportDashboard>,
  ): Observable<{ dashboard: ReportDashboardApiEntity }> {
    return this.http.patch<{ dashboard: ReportDashboardApiEntity }>(
      `/dashboards/${dashboard.id}`,
      null,
      { dashboard },
    );
  }

  public updatePositions(
    changes: Position[],
  ): Observable<{ dashboards: ReportDashboardApiEntity[] }> {
    return this.http.patch<{ dashboards: ReportDashboardApiEntity[] }>(
      '/dashboards/update_positions',
      null,
      { dashboards: changes },
    );
  }

  public removeOne(id: string | number): Observable<{ dashboard: { id: number } }> {
    return this.http.delete(`/dashboards/${id}`);
  }

  public moveComponent(
    componentId: number,
    sourceDashboardId: number,
    targetDashboardId: number,
    grid: ReportDashboardComponentGridPosition,
  ): Observable<void> {
    return this.http.patch(`/dashboards/${sourceDashboardId}/move`, null, {
      component: { id: componentId, dashboardId: targetDashboardId, grid },
    });
  }
}
